import { isClient } from '~/utils/EnvUtils';

export default class CookieService {
  static get(name: string): string | undefined {
    if (!isClient()) {
      return undefined;
    }

    const cookies: Record<string, string> = {};
    document.cookie.split(';').forEach((el) => {
      const [k, v] = el.split('=');
      cookies[k.trim()] = v;
    });

    return cookies[name];
  }

  static getFromRequest(name: string, req: any) {
    if (!req.headers?.cookie) {
      return null;
    }
    // added support for getting cookies from request for ssr usecase
    const cookies: Record<string, string> = {};
    req.headers.cookie.split(';').forEach((el: string) => {
      const [k, v] = el.split('=');
      cookies[k.trim()] = v;
    });
    return cookies[name];
  }

  static set(expiresInSeconds: number, name: string, value: string) {
    if (!isClient()) {
      return;
    }
    let d = new Date();
    d = new Date(d.getTime() + 1000 * expiresInSeconds);
    // earlier in js file, it was .toGMTString() but it is deprecated hence no typings, replaced with similar MDN equivalent
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toUTCString
    const str = `${name} = ${value}; expires=' + ${d.toUTCString()}; path=/;`;
    document.cookie = str;
  }
}
